module.exports = __webpack_public_path__ + "img/client-icon.1c57f905.svg";